import { ENV_DEV } from "../../utils/window";
import getSelector from "./get-selector";
import processStagger from "./process-stagger";

/**
 *
 * @param {GroupClassProps} group
 * @param {String} attributes
 */
const getAttributes = (group, attributes) => {
  const parent = group.element;
  const map = new Map();

  for (const attribute of attributes.split(";")) {
    if (!attribute) {
      continue;
    }

    /** Element index number */
    let index = 0;

    /** Split the attribute to "target" and "values" */
    const split = attribute.split("=>");

    const element = split[0];

    if (ENV_DEV && !element) {
      console.error(
        `[TorusKit error]: No target element defined in the \`${attribute}\``
      );
      return map;
    }

    const selector = getSelector(split[0]);

    /** Get the HTML target elements */
    const targets = /** @type {Array<HTMLElement>} */ (
      Array.from(parent.querySelectorAll(selector))
    );

    if (ENV_DEV && !targets.length) {
      console.warn(
        `[TorusKit warn]: No target elements found for \`${element}\``
      );
      return map;
    }

    /** Get the string values to be set as [data-tor] attribute */
    const values = split[1];

    /** Loop selected target elements */
    for (const target of targets) {
      /** Create a new Set that stores multiple attributes of the same element */
      if (!map.has(target)) {
        map.set(target, new Set());
      }

      const set = /** @type {Set<String>} */ (map.get(target));

      const staggered = processStagger(values, index);

      set.add(staggered);

      map.set(target, set);

      ++index;
    }
  }

  return map;
};

export default getAttributes;
